import { ConfigurationSourceDataMap, CoordinatingGroup, Institution, MasterGroup, Metadata, Participant, SourceData, SourceDataStatus, Trial } from "@/api/dtos";
import ParticipantSourceDataEventStatusList from "@/components/lists/status/ParticipantSourceDataEventStatusList";
import ParticipantSourceDataEventStatusesContext from "@/contexts/data/ParticipantSourceDataEventStatusesContext";
import SourceDataFormContext from "@/contexts/form/SourceDataFormContext";
import useEvents from "@/hooks/form/source-data/useEvents";
import { FC, useContext, useMemo } from "react";

interface ISourceDataEventsProps {
    trial: Trial;
    masterGroup?: MasterGroup;
    coordinatingGroup?: CoordinatingGroup;
    institution?: Institution;
    participant: Participant;
    metadata: Metadata;
    trialConfiguration: ConfigurationSourceDataMap;
    configuration: ConfigurationSourceDataMap;
    sourceData: SourceData;
    preview?: boolean;
}

const SourceDataEvents: FC<ISourceDataEventsProps> = ({
    trial,
    masterGroup,
    coordinatingGroup,
    institution,
    participant,
    metadata,
    trialConfiguration,
    configuration,
    sourceData,
    preview
}) => {
    const { data: statuses, refresh: statusesRefresh } = useContext(ParticipantSourceDataEventStatusesContext);
    const {  queueUpdate} = useContext(SourceDataFormContext);
    
    const statusMapping = useMemo(() => {
        return statuses?.reduce<Record<number, SourceDataStatus>>((a, b) => {
            if (!b?.studyEventOid || !b?.studyEventRepeat) {
                return a;
            }
            
            a[`${b.studyEventOid}-${b.studyEventRepeat}` as any] = b;

            return a;
        }, {})
    }, [statuses])

    const eventData = useEvents(
        metadata,
        trialConfiguration,
        configuration,
        sourceData,
        trial,
        masterGroup,
        coordinatingGroup,
        institution,
        participant,
        preview
    );

    return (
        <>
            <ParticipantSourceDataEventStatusList 
                trial={trial}
                institution={institution}
                participant={participant}
                data={eventData}
                statuses={statusMapping}
                queueUpdate={queueUpdate}
            />
        </>
    )
};

export default SourceDataEvents;